<div style="display: block; margin-left: auto;text-align: center;">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" strokeWidth="4" fill="transparent"
                     animationDuration=".5s">
  </p-progressSpinner>
</div>
